import { render, staticRenderFns } from "./PlanActionRegister.vue?vue&type=template&id=5656a704"
import script from "./PlanActionRegister.vue?vue&type=script&lang=js"
export * from "./PlanActionRegister.vue?vue&type=script&lang=js"
import style0 from "./PlanActionRegister.vue?vue&type=style&index=0&id=5656a704&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports